import { useState } from "react";
import { useEffect } from "react";
import { useForm, useWatch } from "react-hook-form";
import Modal from "react-responsive-modal";
import { Link } from "react-router-dom";
import { ICreateMerchstoreProps, INewMerchstoreProps } from ".";
import { Card } from "@merchstores/shared/elements/Card/component";
import { CTA } from "@merchstores/shared/elements/Cta";
import { FormInput } from "@merchstores/shared/elements/FormInput";
import { FormSelect } from "@merchstores/shared/elements/FormSelect";
import "./styles.scss";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { toast } from 'react-toastify';
import { useContext } from "react";
import { Context } from "../../context";
import { PayerType } from "@merchstores/shared/components/MerchStore";

export const CreateMerchstore = (props: ICreateMerchstoreProps) => {
    const { register, handleSubmit, setValue, setError, reset, formState: { errors }, control } = useForm();
    const history = useHistory();

    const [modalOpen, setModalOpen] = useState(props.modalOpen);
    const [submitDisabled, setSubmitDisabled] = useState(true);
    const { userEmail } = useContext(Context);

    const subdomain = useWatch({
        control,
        name: "subdomain",
        defaultValue: ""
    });

    const payerType = useWatch({
        control,
        name: "payerType",
        defaultValue: null
    });

    const alwaysOpen = useWatch({
        control,
        name: "alwaysOpen",
        defaultValue: ""
    });

    useEffect(() => {
        if (subdomain && subdomain !== "" && payerType && alwaysOpen) {
            setSubmitDisabled(false);
        } else {
            setSubmitDisabled(true);
        }
    }, [subdomain, payerType, alwaysOpen]);

    useEffect(() => {
        if (props.modalOpen !== modalOpen) {
            setModalOpen(props.modalOpen);
        }
    }, [props.modalOpen]);

    const createMerchstore = (form: INewMerchstoreProps) => {
        setSubmitDisabled(true);

        // Check Subdomain format
        const re = /[^a-zA-Z0-9-]/;
        if (re.test(subdomain)) {
            setError("subdomain", { type: "invalid", message: "Valid subdomains can only contain letters, numbers, or the character -" });
        } else {
            toast.info(`Registering ${subdomain}.merchologysolutions.com, please wait...`);
            axios.post('/.netlify/functions/createNetlifySubdomain', {
                subdomain: form.subdomain
            })
                .then((netlifyReponse: any) => {
                    const siteId = netlifyReponse.data;
                    toast.success(`${subdomain}.merchologysolutions.com registered correctly!`);
                    toast.info(`Setting up your store, please wait...`);
                    axios.post('/.netlify/functions/createMerchstore', {
                        store: {
                            subdomain: form.subdomain,
                            payerType: form.payerType,
                            alwaysOpen: form.alwaysOpen,
                            merchologist: userEmail,                            
                            netlifySiteId: siteId
                        }
                    })
                        .then(res => {
                            toast.success(`Your store ${subdomain} was created correctly!`);
                            history.push(`/admin/merchstores/${res.data}`);

                        }).catch(err => {
                            console.error(err);
                            axios.post('/.netlify/functions/deleteNetlifySite', {
                                siteId
                            })
                                .then(() => {
                                    toast.error(`There was an error creating your store. Please try again.`);
                                    setSubmitDisabled(false);
                                })
                                .catch(err => {
                                    console.error(err);
                                    toast.error(`There was an error creating your store. Please contact your administrator.`);
                                });
                        })
                }).catch(err => {
                    if (err?.response?.data?.error) {
                        setError("subdomain", { type: "in-use", message: err.response.data.error });
                    }
                    setSubmitDisabled(false);
                });
        }
    }

    return <Modal open={modalOpen} classNames={{ root: "create-edit-merchstore-modal" }} center={true} onClose={() => {
        setModalOpen(false);
        props.onModalClose();
    }}>
        <Card>
            <h2 className="font-bold">Create New MerchStore</h2>
            <form onSubmit={handleSubmit(createMerchstore)}>
                <div className="mb-30 mt-30">
                    <h3 className="font-medium mb-13">What is the subdomain of your new MerchStore?</h3>
                    <FormInput
                        errors={errors}
                        name="subdomain"
                        register={register}
                        required={true}
                        type="text"
                        htmlSubText={<p><b>{subdomain}</b>.merchologysolutions.com</p>} />
                    <h3 className="font-medium sm:mt-25 mt-30 mb-13">Who will be paying for MerchStore products?</h3>
                    <FormSelect
                        name="payerType"
                        errors={errors}
                        register={register}
                        label=""
                        options={[
                            { displayText: "Individual Employees", value: PayerType.INDIVIDUAL },
                            { displayText: "Administrator", value: PayerType.ADMIN }]}
                        setValue={setValue}
                        emptyText="Select one" />
                    <h3 className="font-medium sm:mt-25 mt-30 mb-13">Will this MerchStore be always open or only open for a limited time?</h3>
                    <FormSelect
                        name="alwaysOpen"
                        errors={errors}
                        register={register}
                        label=""
                        options={[
                            { displayText: "Always Open", value: "true" },
                            { displayText: "Open for a limited time", value: "false" }]}
                        setValue={setValue}
                        emptyText="Select one" />
                </div>
                <CTA type="primary" size="large" formSubmit={true} classes="w-full" disabled={submitDisabled}>Create Store</CTA>
            </form>
            <div className="flex justify-center mt-24 absolute md:relative bottom-40 left-2/4 md:left-auto md:bottom-auto">
                <Link onClick={() => setModalOpen(false)}>Cancel</Link>
            </div>
        </Card>
    </Modal>
}